export default "/img/TC.3278f2117d266e715aeb9d4553d0b77f.png";